import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'homework',
    lazy: async () => ({ Component: (await import('./HomeworkPage')).HomeworkPage }),
  },
];
